// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSUpOrDownText/index.less
// module id = 1004
// module chunks = 42